<template>
  <div id="app" class="font-size" @keydown="Tab($event)">
    <PWAPrompt />
    <!-- <loading v-if="$store.state.loadingRender"></loading> -->
    <router-view></router-view>
    <modal></modal>
  </div>
</template>

<script>
import Modal from './components/Tools/Modal.vue'
import moment from 'moment-jalaali'
import PWAPrompt from './components/PWAPrompt.vue'
import loading from './components/Tools/NetPa/Loading.vue'

export default {
  name: 'App',
  data() {
    return {}
  },
  components: {
    Modal,
    PWAPrompt,
    loading,
  },
  updated() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw < 1080) {
      if (document.getElementById('menu_toggle')) {
        document.getElementById('menu_toggle').click()
      }
    }
    var nodes = document.querySelectorAll('.nav.child_menu')
    var smnodes = document.querySelectorAll('.nav-md')

    if (smnodes.length <= 0) {
      nodes.forEach((element) => {
        element.style.display = 'none'
      })
    }

    this.$ResetTimer()
    window.scrollTo(0, 0)

    this.$store.state.JalaliDateAndTime = moment().format('jYYYY/jMM/jDD _  h:mm a')
    this.$store.state.JalaliDate = moment().format('jYYYY/jMM/jDD')
  },
  methods: {
    Tab(event) {
      if (event.keyCode == 13) {
        var self = event.target

        if ('TEXTAREA' != self.tagName) {
          event.preventDefault()

          var all = document.querySelectorAll('input, select, a , button, Textarea')
          if (['A', 'BUTTON'].includes(self.tagName)) {
            self.click()
          } else {
            var array = []
            all.forEach((element) => {
              if (element.getAttribute('tabindex') != -1 && !element.hidden && !element.disabled) {
                array.push(element)
              }
            })
            var place = array.indexOf(self)
            // console.log(array[place]);
            array[place + 1].focus()
            if (event.target.id == 'PassWord') {
              array[place + 1].click()
            }
          }
        }
      }
    },
    MenuClickhandler(e) {
      if (e.target.parentNode.classList && e.target.parentNode) {
        if (e.target.parentNode.parentNode) {
          if (!(e.target.parentNode.parentNode.classList.contains('child_menu') || e.target.parentNode.parentNode.parentNode.classList.contains('nav') || e.target.parentNode.parentNode.classList.contains('nav'))) {
            var nodes = document.querySelectorAll('.nav.child_menu')
            var smnodes = document.querySelectorAll('.nav-md')
            if (smnodes.length <= 0) {
              nodes.forEach((element) => {
                element.style.display = 'none'
              })
            }
          }
        }
      }
      if (document.querySelectorAll('.nav-md').length > 0) {
        var menus = document.querySelectorAll(' .nav-md .nav.side-menu li a span')
        menus.forEach((element) => {
          element.classList.remove('d-block')
        })
      } else {
        var menus2 = document.querySelectorAll(' .nav-sm .nav.side-menu li a span')
        menus2.forEach((element) => {
          element.classList.add('d-block')
        })
      }
    },
  },
  mounted() {   
    this.$GetAppsettings()
    this.$AutoCloseMenuForMobile()
  },
  created() {
    this.$GetAppsettings()
    // var axios = require("axios");
    // axios.get('/appsettings.json')
    //   .then(res => console.log(res.data))

    // this.gettblCustomer()

    window.addEventListener('click', this.MenuClickhandler)
  },
  beforeMount() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.installEvent = e
      this.shown = true
    })
  },
}
</script>
<style>
apexcharts-legend-series apexcharts-inactive-legend {
  white-space: nowrap !important;
}
.vpd-icon-btn {
  padding: 8px !important;
}
.vpd-time .vpd-time-h .vpd-counter,
.vpd-time .vpd-time-m .vpd-counter {
  font-size: 30px !important;
}
.vpd-time .vpd-time-h .vpd-counter-item,
.vpd-time .vpd-time-m .vpd-counter-item {
  font-size: 30px !important;
}
.vpd-container {
  font-size: 30px !important;
}
.vpd-day-text {
  font-size: 14px !important;
}
.pwa-prompt {
  font-size: 1rem !important;
}

.font-size:not(.custom-font-size) {
  font-size: 12px !important;
}
</style>
